import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import VueRecaptcha from 'vue-recaptcha';
import Contact from 'src/store/models/Contact';
import Construction from 'src/store/models/Construction';
import Typology from 'src/store/models/Typology';
export default {
  name: 'RequestInfoDialog',
  components: {
    VueRecaptcha: VueRecaptcha
  },
  props: ['typologyId', 'contactId', 'contactEmail', 'constructionId', 'show', 'contactType'],
  computed: {
    contactOptions: function contactOptions() {
      switch (this.contactType) {
        case 'sales_companies':
          return this.sales_companies;
        case 'sales_agencies':
          return this.sales_agencies;
        case 'other_sales_agencies':
          return this.other_sales_agencies;
        default:
          return this.sales_agencies;
      }
    },
    typology: function typology() {
      return Typology.query().find(this.typologyId);
    },
    contact: function contact() {
      return Contact.query().find(this.contactId);
    },
    construction: function construction() {
      return Construction.query().with(['contacts', 'company']).find(this.constructionId);
    },
    sales_companies: function sales_companies() {
      return this.construction ? this.construction.contacts.filter(function (contact) {
        return contact.pivot.sales_company;
      }) : [];
    },
    sales_agencies: function sales_agencies() {
      return this.construction ? this.construction.contacts.filter(function (contact) {
        return contact.pivot.sales_agency;
      }) : [];
    },
    other_sales_agencies: function other_sales_agencies() {
      return this.construction ? this.construction.contacts.filter(function (contact) {
        return contact.pivot.other_sales_agency;
      }) : [];
    },
    sendEnabled: function sendEnabled() {
      return this.name && (this.email || this.phone_number) && this.phone_number && this.message && this.agreeToTerms && this.recaptchaCode && (this.sales_agencies.length <= 1 && this.sales_companies.length <= 1 || this.contact_id);
    },
    descriptionLabel: function descriptionLabel() {
      if (this.typology) {
        return "".concat(this.$t('Inserisci qui il tuo messaggio per la tipologia'), " ").concat(this.typology.code);
      }
      return "".concat(this.$t('Inserisci qui il tuo messaggio per l\'annuncio'), " ").concat(this.construction.web_code);
    }
  },
  data: function data() {
    return {
      showDialog: this.show,
      agreeToTerms: false,
      name: '',
      email: '',
      phone_number: '',
      time: '',
      message: '',
      recaptchaCode: '',
      recaptchaKey: process.env.RECAPTCHA_SITE_KEY,
      contact_id: this.contactId
    };
  },
  watch: {
    'showDialog': function showDialog(val) {
      this.$emit('update:show', val);
    },
    'show': function show(val) {
      if (this.contactId) {
        this.contact_id = this.contactId;
      } else if (this.sales_agencies && this.sales_agencies.length === 1) {
        this.contact_id = this.sales_agencies[0].id;
      }
      this.showDialog = val;
    }
  },
  methods: {
    showPrivacyDialog: function showPrivacyDialog() {
      window.open('/statics/legal/informativa_privacy.html', '_blank');
    },
    dialogHidden: function dialogHidden() {
      this.$emit('hidden');
    },
    onVerifyRecaptcha: function onVerifyRecaptcha(response) {
      this.recaptchaCode = response;
    },
    onRecaptchaExpired: function onRecaptchaExpired() {
      this.recaptchaVerified = true;
      this.$refs.recaptcha.reset();
    },
    requestInfo: function requestInfo() {
      var _this = this;
      this.$q.dialog({
        title: 'Conferma email',
        message: 'Verifica se il tuo indirizzo email "' + this.email + '" è corretto.',
        cancel: {
          label: 'Annulla',
          color: 'negative'
        },
        ok: {
          label: 'Conferma',
          color: 'primary'
        },
        persistent: true
      }).onOk(function () {
        _this.$q.loading.show();
        Vue.prototype.$axios.post("/api/constructions/".concat(_this.construction.id, "/request-info"), {
          name: _this.name,
          email: _this.email,
          phone_number: _this.phone_number,
          time: _this.time,
          message: _this.message,
          recaptcha: _this.recaptchaCode,
          contact_id: _this.contact_id,
          contact_email: _this.contactEmail,
          typology_id: _this.typology ? _this.typology.id : null
        }).then(function (response) {
          _this.$q.loading.hide();
          _this.$q.notify({
            type: 'positive',
            message: _this.$t('Messaggio di richiesta inviato con successo!')
          });
          _this.email = '';
          _this.name = '';
          _this.phone_number = '';
          _this.time = '';
          _this.message = '';
          _this.agreeToTerms = false;
          _this.recaptchaCode = '';
          _this.showDialog = false;
        }).catch(function (e) {
          _this.$q.loading.hide();
        });
      });
    }
  }
};